<template>
  <div>
    <img :src="url" alt="" />
    <div
      :style="{ backgroundImage: 'url(' + url + ')', height: '100px' }"
    ></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      img:
        "https://grow-up.obs.cn-east-3.myhuaweicloud.com:443/2021-08-05/28405b1136d60526d2d30f164f9d2c4f.jpg",
      url: "",
    };
  },
  mounted() {
    this.getBase64(this.img).then((res) => {
      this.url = res;
    });
  },
  methods: {
    getBase64(img) {
      return new Promise((resolve, reject) => {
        function getBase64Image(img, width, height) {
          var canvas = document.createElement("canvas");
          canvas.width = width ? width : img.width;
          canvas.height = height ? height : img.height;
          var ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          let ext = img.src
            .substring(img.src.lastIndexOf(".") + 1)
            .toLowerCase();
          let dataURL = canvas.toDataURL("image/" + ext);
          return dataURL;
        }
        if (img) {
          let image = new Image();
          image.src = img + "?v=" + Math.random(); // 处理缓存
          image.crossOrigin = "*"; // 支持跨域图片
          image.onload = (e) => {
            let base64 = getBase64Image(image); //调用函数并将其转为base64图片
            console.log(base64)
            if (base64) {
              resolve(base64);
            } else {
              reject();
            }
          };
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
